// Récupération de la liste des partenaires via la nouvelle route GET /partners/all
export const PRE_GET_PARTNERS_API = 'PRE_GET_PARTNERS_API'; // intent UI / boot
export const RECEIVE_PARTNERS_API = 'RECEIVE_PARTNERS_API'; // consommé par le reducer

// Étape de configuration (POST partnersConfig/step-status)
export const PRE_POST_STEP_STATUS = 'PRE_POST_STEP_STATUS'; // intent UI
export const POST_STEP_STATUS_FINISHED = 'POST_STEP_STATUS_FINISHED'; // maj du partenaire
